// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__hpOh-","choiceBoxes":"toolbarselects_choiceBoxes__2fkTJ","simpleField":"toolbarselects_simpleField__3H4Rd"};